const AuthError = () => {
  return <div>Wrong email or password </div>
}

export default AuthError
